<div class="wrapper-md">
    <app-breadcrumbs [items]="[{ url: '/notification-templates', text: 'notificationTemplate_listTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'notificationTemplate_listTitle' | translate}}</h1>
        <aside>
            <button type="button" class="btn btn-outline-primary" *ngIf="canEdit" [routerLink]="['/notification-templates/add'] | localize">
                <i class="fi fi-rs-plus"></i>
                {{'add' | translate}}
            </button>
        </aside>
    </header>

    <app-table [rows]="items" [columns]="columns">
        <ng-template #rowTemplate let-row>
            <tr>
                <td>{{row.Name}}</td>
                <td>{{row.Type}}</td>
                <td>{{row.SubjectLV}}</td>
                <td>{{row.SubjectEN}}</td>
                <td>
                    <div class="table-actions">
                        <button type="button" *ngIf="canEdit" class="btn btn-outline btn-icon" [routerLink]="['/notification-templates', row.Id] | localize"
                                [ngbTooltip]="'open' | translate">
                            <i class="fi fi-rs-angle-right"></i>
                        </button>

                        <button type="button" (click)="delete(row)" *ngIf="canEdit" class="btn btn-outline-primary btn-icon"
                                [ngbTooltip]="'delete' | translate">
                            <i class="fi fi-rs-trash"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </app-table>
</div>
